var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiCircleFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
    fill: "#F2F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12H21.5C21.5 17.2467 17.2467 21.5 12 21.5V22.5ZM1.5 12C1.5 17.799 6.20101 22.5 12 22.5V21.5C6.75329 21.5 2.5 17.2467 2.5 12H1.5ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12H2.5C2.5 6.75329 6.75329 2.5 12 2.5V1.5ZM22.5 12C22.5 6.20101 17.799 1.5 12 1.5V2.5C17.2467 2.5 21.5 6.75329 21.5 12H22.5ZM12 16.5C14.4853 16.5 16.5 14.4853 16.5 12H15.5C15.5 13.933 13.933 15.5 12 15.5V16.5ZM7.5 12C7.5 14.4853 9.51472 16.5 12 16.5V15.5C10.067 15.5 8.5 13.933 8.5 12H7.5ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12H8.5C8.5 10.067 10.067 8.5 12 8.5V7.5ZM16.5 12C16.5 9.51472 14.4853 7.5 12 7.5V8.5C13.933 8.5 15.5 10.067 15.5 12H16.5Z",
    fill: "#F2F8F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiCircleFull);
export default __webpack_public_path__ + "static/media/fi_circle_full.df048266b5a8978e8ad724b82bcb325c.svg";
export { ForwardRef as ReactComponent };